import { render, staticRenderFns } from "./VipIntrodution.vue?vue&type=template&id=16812714&scoped=true&"
import script from "./VipIntrodution.vue?vue&type=script&lang=ts&"
export * from "./VipIntrodution.vue?vue&type=script&lang=ts&"
import style0 from "./VipIntrodution.vue?vue&type=style&index=0&id=16812714&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16812714",
  null
  
)

export default component.exports